export const queryKeys = {
  BROKER_ALL: 'BROKER_ALL',
  BROKER_COMPACT: 'BROKER_COMPACT',
}
